import { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../utilities/LogErrors'
import { useLanguage } from './../../../utilities/LanguageContext'

import { ValidateSession } from './../../../utilities/BL/Sessions'

//Componentes personalizados del proyecto
//import { Blocks } from './../Blocks'
import { Blocks } from './../V2/Blocks'

//Componentes comunes generales
//import { Header } from './../../Header/Header'
import { Header } from './../../Header/V2/Header'

import { Loading } from './../../Common/Loading'
import { SearchInput } from './../SearchInput'

//Funciones personalizadas del proyecto
import { GetChoosenCourse, GetCourseProgress as BLGetCourseProgress, GetCourseProgressInstructor as BLGetCourseProgressInstructor } from './../../../utilities/BL/Student/Courses' //ResetChoosenCourse
//import { ResetInstrumentToShow } from './../../../utilities/BL/Navigation'
import { GetAndSaveInstrumentToShow, GetInstrumentName } from './../../../utilities/BL/Student/Instruments'
import { GoToBack } from './../../Common/GoToBack'
import { GoToTop } from './../../Common/GoToTop'
import { EnableAllRestrictions, DisableAllRestrictions } from './../../../utilities/BL/Security'
import { Credits } from './../../Common/Credits/Credits'
import { ProgressBar } from './../../Common/ProgressBar'
import { GetCenterSettings } from './../../../utilities/BL/Instructor/Settings'
import { HELP_TYPE } from './../../../utilities/EL/HelpType'
import { BodyWithSideMenu } from '../../Dashboard/BodyWithSideMenu'
import { WEBPAGES } from '../../../utilities/EL/WebPages'
import { TYPE_PROPOSITION_VALUE } from '../../../utilities/EL/TypePropositionValue'
import { ROLES } from '../../../utilities/EL/Roles'


const Course = () => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)
    const [session, setSession] = useState({})
    const [theme, setTheme] = useState(null)

    const [course, setCourse] = useState(null) // {}
    const [courseInstruments, setCourseInstruments] = useState(null) // {}
    const [quickaccessName, setQuickaccessName] = useState(null)
    const [isObjectiveVisible, setIsObjectiveVisible] = useState(false)

    const [courseProgress, setCourseProgress] = useState(null)
    const [urlToBack, setUrlToBack] = useState(null)

    const [isInstructor, setIsInstructor] = useState(false)

    const rolesData = {
        ZTUDIANTE: 1,
        INSTRUCTOR: 2,
        PROGRESS: 3
    }


    const GoToNextView = async () => {
        try {
            const response = await GetAndSaveInstrumentToShow(session)

            if (response.success) {
                navigate('/viewer')
            } else {
                //Mostrar mensaje de que no se puedo obtener la info o el error
                console.log(response.message) //Mensaje temporal
            }
        } catch (error) {
            await LogErrors('GoToNextView - Course', error)
        }
    }

    const LoadPage = async (sessionInfo) => {
        try {
            setIsLoading(true)
            setTheme(sessionInfo.user.userTheme)
            
            document.body.classList.add('BodyComplete')
            
            let response = null
            const role = sessionInfo?.navigation?.role?.id

            if (!role) {
                //console.log('')
                return
            }
            
            if (role === rolesData.ZTUDIANTE) {
                response = await GetChoosenCourse(role)
                setIsInstructor(false)
                
            } else if (role === rolesData.INSTRUCTOR) {
                response = await GetChoosenCourse(role)
                setIsInstructor(true)
            }
            
            if (response.success) {
                if (sessionInfo?.navigation?.course?.goToQuickAccessInstrument) {
                    //const tmpResponse = await GetAndSaveInstrumentToShow(sessionInfo)
                    const courses = response?.data?.courses

                    if (!courses) {
                        return
                    }

                    const tmpResponse = await GetAndSaveInstrumentToShow(courses)

                    if (tmpResponse.success) {
                        navigate('/viewer')
                    } else {
                        //Mostrar mensaje de que no se puedo obtener la info o el error
                        console.log(tmpResponse?.message) //Mensaje temporal
                    }
                } else {
                    //setCourse(sessionInfo.navigation.course)
                    const course = response?.data?.navigation?.course
                    if (!course) {
                        setCourse(null)
                    }

                    const courses = response?.data?.courses
                    if (!courses) {
                        setCourse(null)
                    }

                    setCourse(course)
                    setCourseInstruments(courses)
                    
                    let progressResp
                    
                    if (role === rolesData.ZTUDIANTE) {
                        // 1) Obtener avance del curso (una vez que ya sabemos qué curso es)
                        progressResp = await BLGetCourseProgress()
                        
                        if (progressResp?.success) {
                            setCourseProgress(progressResp?.data?.progress ?? null)
                            //setCourseProgress(null) // Para pruebas
                        } else {
                            setCourseProgress(null) // fallback
                        }
                        
                        setUrlToBack(response?.data?.navigation?.course?.urlToBack || '/dashboard')

                    }  else if (role === rolesData.INSTRUCTOR) {
                        const idUser = response?.data?.navigation?.course?.idUser
                        // 1) Obtener avance del curso (una vez que ya sabemos qué curso es)
                        if (idUser) {
                            progressResp = await BLGetCourseProgressInstructor(idUser)
                            
                            if (progressResp?.success) {
                                setCourseProgress(progressResp?.data?.progress ?? null)
                                //setCourseProgress(null) // Para pruebas
                            } else {
                                setCourseProgress(null) // fallback
                            }
                        }

                        //setUrlToBack('/instructor/progress')
                        setUrlToBack(response?.data?.navigation?.course?.urlToBack || '/dashboard')
                    }
                    


                    //const tmpQuickaccessName = await GetInstrumentName(sessionInfo)
                    const tmpQuickaccessName = await GetInstrumentName(response.data)

                    if (tmpQuickaccessName.success) {
                        setQuickaccessName(tmpQuickaccessName?.data ?? null)
                    } else {
                        if (tmpQuickaccessName.message !== '') {
                            //Mostrar mensaje de que no se puedo obtener la info o el error
                            console.log(tmpQuickaccessName.message) //Mensaje temporal
                        }
                    }
                    
                    // Abrir el bloque donde se encuentra el tema que se había seleccionado antes de enviar a la página Viewer
                    //const idInstrument = sessionInfo?.navigation?.instrument?.id
                    const idInstrument = response?.data?.navigation?.instrument?.id

                    if (idInstrument !== undefined && idInstrument !== null) {
                        const foundBlockIndex = response.data.courses.blocks.findIndex(block =>
                            block.items.some(item => item.id === parseInt(idInstrument))
                        )

                        if (foundBlockIndex !== -1) {
                            // Pasamos el bloque a abrir al estado de Blocks.js
                            setTimeout(() => {
                                document.getElementById(`block-${foundBlockIndex}`)?.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                })
                            }, 500)
                        }
                    }
                    
                    //await ResetInstrumentToShow(sessionInfo)
                }
            } else {
                //Mostrar mensaje de que no se puedo obtener la info o el error
                console.log(response?.message) //Mensaje temporal
            }
        } catch (error) {
            await LogErrors('LoadPage - Course', error)    
        } finally {
            setIsLoading(false)
        }
    }

    // 2) Construir lookup por bloque para el hijo (idBlock → datos de progreso)
    const progressByBlockLookup = useMemo(() => {
        if (!courseProgress?.byBlock) return {}

        // byBlock viene con claves string ("1","2"...). Normalizamos a string.
        const map = {}
        
        for (const [blockIdStr, data] of Object.entries(courseProgress.byBlock)) {
            // sets para consulta O(1)
            const approvedSet = new Set(data?.approvedItemIds ?? [])
            const viewedSet = new Set(data?.viewedItemIds ?? [])
            map[blockIdStr] = {
                blockName: data?.blockName ?? '',
                approvedSet,
                viewedSet,
                approvedCount: data?.approvedCount ?? 0,
                viewedCount: data?.viewedCount ?? 0,
                percentageApproved: data?.percentageApproved ?? 0,
                percentageViewed: data?.percentageViewed ?? 0,
                totalItem: data?.totalItem ?? 0
            }
        }

        return map
    }, [courseProgress])

    // 3) Avance general (summary)
    const generalPercentage = useMemo(() => {
        if (!courseProgress?.summary) return 0
        return Number(courseProgress.summary.percentageApproved ?? 0)
    }, [courseProgress])

    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            setSession(tmpSession.data)
    
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage(tmpSession.data)
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar

    const ToggleCourseObjective = async () => {
        try {
            setIsObjectiveVisible(!isObjectiveVisible)
        } catch (error) {
            await LogErrors('ToggleCourseObjective - Course', error)
        }
    }

    useEffect(() => {
        EnableAllRestrictions()

        return () => {
            DisableAllRestrictions()
        }
    }, [])


    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <BodyWithSideMenu page={WEBPAGES.ZTUDENT.COURSE} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.COURSE} role={ROLES.ZTUDENT}>
                        <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.COURSE} />

                        <main className='container Course Container-FullHeight'>
                            <GoToBack url={urlToBack} />

                            {course && courseInstruments ? (
                                <>
                                    <div className='Course-Info'>
                                        <div className='Course-Text'>
                                            {course?.name && course?.level && course?.type && (
                                                <>
                                                    <p className='Course-Name'>{`${course.name} nivel ${course.level === 1 ? translate('labels.course.levels.one') : translate('labels.course.levels.two')}`}</p>
                                                    <p className='Course-Type'>{course.type === 1 ? translate('labels.dashboard.tiles.examType.certification') : translate('labels.dashboard.tiles.examType.custom')}</p>
                                                </>
                                            )}
                                            {/* <div className='Course__ProgressBar'>
                                                <ProgressBar percentageCompleted={10} customClassName={'Course__ProgressBar__Bar'} />
                                                <span className='Course__ProgressBar__Text'>Avance general 10%</span>
                                            </div> */}

                                            {/* Avance general */}
                                            {generalPercentage ? (
                                                <div className='Course__ProgressBar'>
                                                    <ProgressBar percentageCompleted={generalPercentage} customClassName={'Course__ProgressBar__Bar'} />
                                                    <span className='Course__ProgressBar__Text'>
                                                        Avance general {generalPercentage}%
                                                    </span>
                                                </div>
                                            ) : null}
                                            
                                            {courseInstruments.objective && courseInstruments.objective !== '' && (
                                                <>
                                                    <button type='button' className='Course-Objective-Button' onClick={ToggleCourseObjective}>{isObjectiveVisible ? 'Ocultar objetivo del curso' : 'Ver objetivo del curso'}</button>
                                                    
                                                    <div className={`Course-Objective ${isObjectiveVisible ? 'Course-Objective-Show' : ''}`}>
                                                        <p className='Course-Objective-Title'>{translate('labels.course.courseObjective')}</p>
                                                        <p className='Course-Objective-Text'>{courseInstruments.objective}</p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    {(!isInstructor && quickaccessName) && (
                                        <>
                                            <p className='Course-Title'>{translate('labels.course.continueLegend')}</p>
                                            
                                            <button type='button' className='Course-Button' onClick={() => GoToNextView()}>
                                                <span className='Course-Button-Text'>{quickaccessName && quickaccessName !== '' && quickaccessName}</span>
                                            </button>
                                        </>
                                    )}

                                    {courseInstruments.blocks && (
                                        courseInstruments.blocks.length > 0 && (
                                            <>
                                                <p className='Course-Title'>{translate('labels.course.topicsTitle')}</p>
                                                <SearchInput placeholder={`${translate('labels.course.searchInput')}`} session={session} courseInstruments={courseInstruments} />
                                            </>
                                        )
                                    )}

                                    <div className='Course-Topics'>
                                        {courseInstruments.blocks && (
                                            courseInstruments.blocks.length === 0 ? (
                                                <p>Este curso actualmente no tiene bloques.</p>
                                            ) : (
                                                <Blocks blocks={courseInstruments.blocks} session={session} setSession={setSession} quickaccessName={quickaccessName} progressByBlockLookup={progressByBlockLookup} isInstructor={isInstructor} />
                                            )
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className='Course-Info'>
                                    <div className='text-center'>
                                        <p>No ha sido posible obtener la información del curso.</p>
                                        <p>Actualiza la página para solucionarlo.</p>
                                    </div>
                                </div>
                            )}
                        </main>
                    </BodyWithSideMenu>
                </>
            )}
        </>
    )  
}

export { Course };